import { RouteObject } from 'react-router-dom';
import RAIDRLayoutV2 from '../components/layout/layouts/RAIDRLayoutV2.component';
import PageNotFound from '../components/settings/pages/PageNotFound.component';
import { UnconventionalRedirect } from './Router';
import { RaidrV2RoutePaths } from './page-routes';
import KidsOverviewV2Page from '../components/pages/raidr/kidsV2/overview/KidsOverviewV2Page';
import KidsEditorV2Page from '../components/pages/raidr/kidsV2/editor/KidEditorV2Page';
import KidsReviewV2Page from '../components/pages/raidr/kidsV2/review/KidsReviewV2Page';
import KidsViewV2Page from '../components/pages/raidr/kidsV2/view/KidsViewV2Page';
import KidsCompareV2Page from '../components/pages/raidr/kidsV2/review/KidsCompareV2Page';
import TemplateManagement from '../components/pages/utilities/TemplateManagement/TemplateManagement.component';
import TemplateEditPage from '../components/pages/utilities/TemplateManagement/TemplateEditPage.component';

export const RaidrV2Routes = (): RouteObject[] => [
  {
    path: RaidrV2RoutePaths.RAIDR_V2,
    element: <RAIDRLayoutV2 />,
    children: [
      {
        index: true,
        path: '',
        element: <UnconventionalRedirect hardSection={'raidr-v2'} />,
      },
      {
        path: RaidrV2RoutePaths.KID_OVERVIEW_V2,
        element: <KidsOverviewV2Page />,
      },
      {
        path: RaidrV2RoutePaths.KID_EDITOR_V2,
        element: <KidsEditorV2Page />,
      },

      {
        path: RaidrV2RoutePaths.KID_REVIEW_V2,
        element: <KidsReviewV2Page />,
      },
      {
        path: RaidrV2RoutePaths.KID_VIEW_V2,
        element: <KidsViewV2Page />,
      },
      {
        path: RaidrV2RoutePaths.KID_COMPARE_V2,
        element: <KidsCompareV2Page />,
      },
      {
        path: RaidrV2RoutePaths.TEMPLATE_MANAGEMENT,
        element: <TemplateManagement />,
      },
      {
        path: RaidrV2RoutePaths.TEMPLATE_EDIT,
        element: <TemplateEditPage />,
      },
      {
        path: RaidrV2RoutePaths.NOT_FOUND,
        element: <PageNotFound />,
      },
    ],
  },
];
